import React from 'react';

export const formatMessage = (message, values) => {
  if (!(values && typeof values === 'object')) {
    // no templating required
    return message;
  }

  // values object is defined, try templating this string
  let hasNode = false;

  const templateParts = message.split(/[{}]/g).map((part, i) => {
    let resultPart = part;

    // every other part is a key
    if (i % 2) {
      const conditionalMatch = part.match(/^(.*)\?(.*)\:(.*)$/);

      if (!conditionalMatch) {
        // part is a normal key
        resultPart = values[part];
      } else {
        // part is a conditional key
        const [, operand, truePart, falsePart] = conditionalMatch;

        resultPart = values[operand] ? truePart : falsePart;

        resultPart =
          resultPart in values ? values[resultPart] : resultPart;
      }
    }

    hasNode = hasNode || typeof resultPart === 'object';
    return resultPart;
  });

  return hasNode
    ? templateParts.map((child, key) =>
        React.cloneElement(<>{child}</>, { key })
      )
    : templateParts.join('');
};

export default formatMessage;
